export default "__VITE_ASSET__vKV_TsKL__"